var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5625 7.5C2.25312 7.5 2 7.24687 2 6.9375V5.0625C2 4.75313 2.25312 4.5 2.5625 4.5H3.5V2.25C3.5 1.00781 4.50781 0 5.75 0H20.75C21.9922 0 23 1.00781 23 2.25V21.75C23 22.9922 21.9922 24 20.75 24H5.75C4.50781 24 3.5 22.9922 3.5 21.75V19.5H2.5625C2.25312 19.5 2 19.2469 2 18.9375V17.0625C2 16.7531 2.25312 16.5 2.5625 16.5H3.5V13.5H2.5625C2.25312 13.5 2 13.2469 2 12.9375V11.0625C2 10.7531 2.25312 10.5 2.5625 10.5H3.5V7.5H2.5625ZM13.25 6C11.5953 6 10.25 7.34531 10.25 9C10.25 10.6547 11.5953 12 13.25 12C14.9047 12 16.25 10.6547 16.25 9C16.25 7.34531 14.9047 6 13.25 6ZM8 17.1C8 17.5969 8.46875 18 9.05 18H17.45C18.0312 18 18.5 17.5969 18.5 17.1V16.2C18.5 14.7094 17.0891 13.5 15.35 13.5H15.1156C14.5391 13.7391 13.9109 13.875 13.25 13.875C12.5891 13.875 11.9563 13.7391 11.3844 13.5H11.15C9.41094 13.5 8 14.7094 8 16.2V17.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address-book.ee5fd1e5f1ecb18e1e5acdd520834179.svg";
export { ForwardRef as ReactComponent };